import { render, staticRenderFns } from "./modelTwo.vue?vue&type=template&id=f52950d4&scoped=true&"
import script from "./modelTwo.vue?vue&type=script&lang=js&"
export * from "./modelTwo.vue?vue&type=script&lang=js&"
import style0 from "./modelTwo.vue?vue&type=style&index=0&id=f52950d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52950d4",
  null
  
)

export default component.exports